import { ReactNode } from 'react';
import { Content, Text } from '@kinesis/bungle';

const TextBlock = (props: TextBlockProps) => {
  const { children } = props;
  return (
    <Content maxWidth={700}>
      <Text>{children}</Text>
    </Content>
  );
};

type TextBlockProps = {
  children: ReactNode;
};
export { TextBlock };
